import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Dropdown, Button, Badge } from "react-bootstrap";
import Question from "./Question";
import api from "utils/axiosInstance";
import { UserContext } from "context/User/UserContext";

export default function QuizReport() {
  const { quizId } = useParams();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const location = useLocation();
  const { user } = useContext(UserContext);

  const [reportState, setReportState] = useState(location.state);

  const handleSelect = (eventKey) => {
    setSelected(eventKey);
  };

  async function getQuizReport(quizId) {
    try {
      const quizReport = await api({
        method: "get",
        url: `/edu/module/quiz/submission/${user.username}/${quizId}`,
      });
      setReportState(quizReport.data);
      navigate(process.env.PUBLIC_URL + `/subject/quiz/report/${quizId}`);
    } catch (err) {
      if (err.response?.data) alert(err.response.data);
      else alert("Error");
    }
  }

  useEffect(() => {
    if (quizId && !isNaN(quizId) && Number(quizId) % 1 === 0) {
      getQuizReport(quizId);
    }
  }, []);

  const handleGetReport = () => {
    if (selected) {
      getQuizReport(selected);
    }
  };

  const CorrectMark = () => (
    <div className="d-inline-block text-center">
      <Badge bg="success" className="fs-6">
        Correct Answer
      </Badge>
      <div className="mt-1 invisible">Correct Answer: Option 1</div>
    </div>
  );

  const IncorrectMark = ({ correctOption }) => (
    <div className="d-inline-block text-center">
      <Badge bg="danger" className="fs-6">
        Wrong Answer
      </Badge>
      <div className="mt-1">Correct Answer: Option {correctOption}</div>
    </div>
  );

  return (
    <Container className="mt-4">
      {quizId && reportState ? (
        <Row>
          <Col>
            {reportState.questions.map((question) => (
              <Question
                key={question.questionId}
                questionIdx={question.questionId - 1}
                totalQuestions={
                  reportState.questions ? reportState.questions.length : 0
                }
                questionText={question.questionText}
                options={[
                  question.option1,
                  question.option2,
                  question.option3,
                  question.option4,
                ]}
                //Could be needed to reduce by 1
                selections={question.selectedOption - 1}
                isMultipleChoice={false}
                readonly={true}
                label={
                  question.selectedOption === question.correctOption ? (
                    <CorrectMark />
                  ) : (
                    <IncorrectMark correctOption={question.correctOption} />
                  )
                }
                className={
                  question.selectedOption === question.correctOption
                    ? "border border-success p-3"
                    : "border border-danger p-3"
                }
              />
            ))}
          </Col>
        </Row>
      ) : (
        <Row className="align-items-center">
          <Col md={4}>
            <Dropdown onSelect={handleSelect}>
              <label>
                Select the week number for which you want to fetch the quiz
              </label>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selected && `Week ${selected}`}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {[1, 2, 3, 4, 5, 6].map((num) => (
                  <Dropdown.Item key={num} eventKey={num}>
                    {num}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col md={2}>
            <Button
              variant="success"
              disabled={!selected}
              onClick={handleGetReport}
            >
              Get Report
            </Button>
          </Col>
        </Row>
      )}
    </Container>
  );
}
